import { api } from "@";
import { searchValuesPayload } from "../lib/helpers";
import type { SearchValues, UpdateGiftOrderNamesPayload } from "../types";

export const getGiftOrders = (
  page = 1,
  perSize: number | null = null,
  search: Partial<SearchValues> = {},
) => {
  return api.post(
    `/api/AdminOrder/get-gift-project-orders`,
    searchValuesPayload(page, perSize, search),
  );
};

export const reSendOrder = (orderItemId: number) => {
  return api.post(`/api/AdminSms/send-gift-order-sms/${orderItemId}`);
};

interface GiftProjectOption {
  value: string;
  label: string;
}

export const getGiftProjects = async (): Promise<GiftProjectOption[]> => {
  try {
    const { data } = await api.get(`/api/AdminOrder/orderItems-gift-projects`);
    return (
      data?.data?.giftProjects?.map(
        (option: { name: string }): GiftProjectOption => ({
          value: option.name,
          label: option.name,
        }),
      ) || []
    );
  } catch (error) {
    return [];
  }
};

export const getGiftProjectAttributes = async (giftProjectId: number) => {
  try {
    const { data } = await api.get(
      `/api/AdminGiftProject/gift-projects/${giftProjectId}/attributes`,
    );
    return data || [];
  } catch (error) {
    return [];
  }
};

export const saveOrderAttribute = (order: {
  orderItemId: number | string;
  attributeId: number | string;
}) => {
  return api.patch(`/api/AdminOrder/regenerate-gift-order-design`, {
    orderItemId: parseInt(String(order.orderItemId)),
    giftProjectAttributeId: parseInt(String(order.attributeId)),
  });
};

export const updateGiftOrderNames = async (
  payload: UpdateGiftOrderNamesPayload,
) => {
  return api.put(`/api/AdminGiftProject/update-gift-receiver-name`, {
    orderItemId: payload.orderItemId,
    giftReceiverName: payload.giftRecieverName,
    senderName: payload.giftSenderName,
  });
};
